import { initializeEventsAPI } from './events';
import { initializeExceptionsAPI } from './exceptions';
import { initializeLogsAPI } from './logs';
import { initializeMeasurementsAPI } from './measurements';
import { initializeMetaAPI } from './meta';
import { initializeTracesAPI } from './traces';
import { initializeUserActionsAPI } from './userActions';
export function initializeAPI(unpatchedConsole, internalLogger, config, metas, transports) {
    internalLogger.debug('Initializing API');
    const userActionsApi = initializeUserActionsAPI({
        transports,
        config,
        internalLogger,
    });
    const tracesApi = initializeTracesAPI(unpatchedConsole, internalLogger, config, metas, transports);
    const props = {
        unpatchedConsole,
        internalLogger,
        userActionsApi,
        config,
        metas,
        transports,
        tracesApi,
    };
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, tracesApi), initializeExceptionsAPI(props)), initializeMetaAPI(props)), initializeLogsAPI(props)), initializeMeasurementsAPI(props)), initializeEventsAPI(props)), userActionsApi);
}
//# sourceMappingURL=initialize.js.map